// extracted by css-extract-rspack-plugin
export default {"titleBox":"titleBox-XSQJJc","titleFont":"titleFont-ObVsuo"};